import {
    SquareAcademicCapBoldDuotoneIcon,
    PrinterBoldDuotoneIcon,
    Routing2BoldDuotoneIcon,
    QuestionSquareBoldDuotoneIcon,
    FireBoldDuotoneIcon,
    BookBookmarkBoldDuotoneIcon,
    CalculatorMinimalisticBoldDuotoneIcon,
    NotebookBoldDuotoneIcon,
    WidgetBoldDuotoneIcon,
    ClipboardCheckBoldDuotoneIcon,
    ChecklistMinimalisticBoldDuotoneIcon,
} from '@solar-icons/react';
import FeatureTile from './FeatureTile';
import styles from './FeatureGrid.module.css';

const TILE_STYLE = {
    lessons: {icon: SquareAcademicCapBoldDuotoneIcon, tone: 'accent', hero: true},
    resources: {icon: PrinterBoldDuotoneIcon, tone: 'secondary'},
    walkthrough: {icon: Routing2BoldDuotoneIcon, tone: 'raised'},
    questions: {icon: QuestionSquareBoldDuotoneIcon, tone: 'raised'},
    scorcher: {icon: FireBoldDuotoneIcon, tone: 'inverse'},
    dictionary: {icon: BookBookmarkBoldDuotoneIcon, tone: 'secondary'},
    // Cambridge LANTITE Edge (content/lantite.js).
    numeracy: {icon: CalculatorMinimalisticBoldDuotoneIcon, tone: 'accent', hero: true},
    literacy: {icon: NotebookBoldDuotoneIcon, tone: 'secondary'},
    widgets: {icon: WidgetBoldDuotoneIcon, tone: 'raised'},
    testing: {icon: ClipboardCheckBoldDuotoneIcon, tone: 'inverse'},
    preparation: {icon: ChecklistMinimalisticBoldDuotoneIcon, tone: 'secondary'},
};

// LANTITE's tiles sit beside their HOTmaths counterparts, so its page follows the same run of tones.
const DISPLAY_ORDER = ['lessons', 'numeracy', 'resources', 'literacy', 'walkthrough', 'scorcher', 'testing',
    'questions', 'widgets', 'dictionary', 'preparation'];

export default function FeatureGrid({content}) {
    const items = [...content.items].sort(
        (a, b) => DISPLAY_ORDER.indexOf(a.icon) - DISPLAY_ORDER.indexOf(b.icon)
    );

    return (
        <section className={styles.section} aria-labelledby="home-features">
            <div className={styles.inner}>
                <h2 id="home-features" className={styles.heading}>{content.heading}</h2>
                <ul className={styles.grid}>
                    {items.map((item) => {
                        const tileStyle = TILE_STYLE[item.icon];
                        if (!tileStyle) {
                            return null;
                        }
                        return (
                            <FeatureTile
                                key={item.label}
                                label={item.label}
                                icon={tileStyle.icon}
                                tone={tileStyle.tone}
                                hero={tileStyle.hero}/>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
}
